// eslint-disable-next-line sonarjs/slow-regex, sonarjs/duplicates-in-character-class, sonarjs/concise-regex
const URL_PATTERN = new RegExp('((http|https)(://))?([a-zA-Z0-9]+[.]{1}){2}[a-zA-z0-9]+(/{1}[a-zA-Z0-9]+)*/?', 'i');

export function parseIdFromYoutubeVideoUrl(url: string): string {
	if (!URL_PATTERN.exec(url)?.length) {
		// no url, maybe the videoId;
		return url;
	} else {
		const regex = new RegExp('v=([^&]+)');
		const result = regex.exec(url);
		if (result != null && result.length > 1) {
			return result[1];
		}
		return '';
	}
}
